(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lb-purchase-details"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lb-purchase-details')) {
    customElements.define('lb-purchase-details', class extends HTMLElement {
      static model(variant, quantity, option) {
        const units = Math.max(1, Math.trunc(Number(quantity) || 1));
        let dispatch = 'confirm';
        if (!variant.available) dispatch = 'unavailable';
        else if (variant.inventory_managed) {
          if (variant.inventory_quantity >= units) dispatch = 'ready';
          else if (variant.inventory_policy === 'continue') {
            dispatch = variant.inventory_quantity > 0 ? 'quantity_backorder' : 'made_to_order';
          } else dispatch = 'unavailable';
        }
        let eligible = Boolean(option && option.visible && variant.available && variant.requires_shipping);
        if (eligible && option.rule === 'out_of_stock' && variant.inventory_managed && variant.inventory_quantity > 0) eligible = false;
        const allocation = (variant.allocations || []).find((plan) => String(plan.id) === String(option?.planId))
          || ((variant.allocations || []).length === 1 ? variant.allocations[0] : null);
        const deposit = eligible && option.mode === 'deposit' && allocation
          && Number.isFinite(allocation.due_now) && Number.isFinite(allocation.remaining);
        const mode = deposit ? 'deposit' : eligible && option.mode === 'full' ? 'full' : 'standard';
        const unitPrice = deposit ? allocation.price : variant.price;
        const total = unitPrice * units;
        const dueNow = deposit ? allocation.due_now * units : total;
        const remaining = deposit ? allocation.remaining * units : 0;
        return { quantity: units, dispatch, mode, unitPrice, total, dueNow, remaining, savings: Math.max(0, variant.price * units - total) };
      }

      connectedCallback() {
        this.form = document.getElementById(this.dataset.formId);
        this.scope = this.closest('product-info') || this.closest('.shopify-section');
        this.observerRoot = this.closest('.shopify-section') || this.scope;
        if (!this.form || !this.scope || this.initialized) return;
        this.initialized = true;
        this.variants = JSON.parse(this.querySelector('[data-lb-variants]').textContent);
        this.messages = JSON.parse(this.querySelector('[data-lb-messages]').textContent);
        this.bundleLinks = this.querySelector('[data-lb-bundle-links]')
          ? JSON.parse(this.querySelector('[data-lb-bundle-links]').textContent) : {};
        this.numberFormat = new Intl.NumberFormat(this.dataset.locale || 'en-AU', {
          style: 'currency', currency: this.dataset.currency || 'AUD'
        });
        this.schedule = () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.update());
        };
        this.observerRoot.addEventListener('change', this.schedule);
        this.observerRoot.addEventListener('input', this.schedule);
        this.observer = new MutationObserver((records) => {
          if (records.some((record) => {
            const target = record.target.nodeType === Node.ELEMENT_NODE ? record.target : record.target.parentElement;
            if (!target || this.contains(target) || target.closest('[data-lb-sticky-summary]')) return false;
            if (record.type === 'attributes' && record.attributeName.startsWith('data-lb-')) return false;
            return true;
          })) this.schedule();
        });
        this.observer.observe(this.observerRoot, { childList: true, subtree: true, attributes: true, characterData: true });
        this.schedule();
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.observer?.disconnect();
        this.observerRoot?.removeEventListener('change', this.schedule);
        this.observerRoot?.removeEventListener('input', this.schedule);
        this.initialized = false;
      }

      text(element, value) {
        if (element && element.textContent !== value) element.textContent = value;
      }

      hide(element, hidden) {
        if (element && element.hidden !== hidden) element.hidden = hidden;
      }

      attribute(element, name, value) {
        if (element && element.getAttribute(name) !== value) element.setAttribute(name, value);
      }

      money(value) {
        return this.numberFormat.format(value / 100);
      }

      update() {
        const selector = this.scope.querySelector('variant-radios, variant-selects');
        if (selector && Object.hasOwn(selector, 'currentVariant') && !selector.currentVariant) {
          this.attribute(this.observerRoot, 'data-lb-selection-valid', 'false');
          this.hide(this.querySelector('[data-lb-summary]'), true);
          this.hide(this.querySelector('[data-lb-instalment-note]'), true);
          this.text(this.querySelector('[data-lb-dispatch]'), this.messages.unavailable);
          const nativeLabel = this.form.querySelector('button[name="add"] > span')?.textContent || this.messages.sold_out;
          Array.from(document.querySelectorAll('.sticky-atc-button')).filter((button) => button.getAttribute('form') === this.dataset.formId).forEach((button) => {
            if (!button.disabled) button.disabled = true;
            this.text(button.querySelector(':scope > span'), nativeLabel);
            button.closest('.sticky-atc')?.querySelectorAll('.sticky-atc-price').forEach((price) => this.hide(price, true));
          });
          return;
        }
        this.attribute(this.observerRoot, 'data-lb-selection-valid', 'true');
        const variantId = this.form.querySelector('[name="id"]')?.value;
        const variant = this.variants.find((item) => String(item.id) === String(variantId));
        if (!variant) return;
        const bundleLink = this.querySelector('[data-lb-bundle-link]');
        if (bundleLink && this.bundleLinks[String(variant.id)]) bundleLink.href = this.bundleLinks[String(variant.id)];
        this.attribute(this.observerRoot, 'data-lb-physical', String(variant.requires_shipping));
        const quantityInput = Array.from(this.form.elements).find((input) => input.name === 'quantity');
        const quantity = quantityInput?.value || this.scope.querySelector('[name="quantity"]')?.value || 1;
        const widgets = Array.from(this.scope.querySelectorAll('.dpl[data-depositly-block]'));
        const isVisible = (widget) => !widget.hidden && getComputedStyle(widget).display !== 'none';
        const widget = widgets.find(isVisible) || widgets[0];
        const option = {
          visible: Boolean(widget && isVisible(widget)),
          rule: widget?.dataset.dplDisplayRule,
          discountPercent: widget?.dataset.discountPct,
          mode: widget?.querySelector('input[name="dpl-mode"]:checked')?.value,
          planId: this.form.querySelector('[name="selling_plan"]')?.value
        };
        const model = this.constructor.model(variant, quantity, option);
        this.attribute(this.observerRoot, 'data-lb-payment-mode', model.mode);
        const dispatch = this.querySelector('[data-lb-dispatch]');
        if (dispatch) {
          this.hide(dispatch, !variant.requires_shipping);
          this.text(dispatch, this.messages[model.dispatch]);
          this.attribute(dispatch, 'data-dispatch-state', model.dispatch);
          this.attribute(dispatch, 'data-variant-id', String(variant.id));
        }
        const values = {
          quantity: String(model.quantity), unit_price: this.money(model.unitPrice),
          total: this.money(model.total), savings: this.money(model.savings),
          due_now: this.money(model.dueNow), remaining: this.money(model.remaining)
        };
        for (const [key, value] of Object.entries(values)) this.text(this.querySelector('[data-lb-value="' + key + '"]'), value);
        this.hide(this.querySelector('[data-lb-summary]'), !variant.available);
        this.hide(this.querySelector('[data-lb-delivery-note]'), !variant.requires_shipping);
        this.hide(this.querySelector('[data-lb-savings-row]'), model.savings === 0);
        this.hide(this.querySelector('[data-lb-now-row]'), model.mode !== 'deposit');
        this.hide(this.querySelector('[data-lb-balance-row]'), model.mode !== 'deposit');
        const balanceNote = this.querySelector('[data-lb-balance-note]');
        const dueType = widget?.dataset.dueType || widget?.querySelector('[data-due-type]')?.dataset.dueType;
        this.text(balanceNote, dueType === 'on_fulfillment' ? this.messages.balance_on_fulfillment : this.messages.balance_terms);
        this.hide(balanceNote, model.mode !== 'deposit');
        const neutralPayment = model.mode === 'deposit' || (model.mode === 'full' && Number(option.discountPercent) > 0) || model.quantity > 1;
        const instalments = this.observerRoot.querySelectorAll('square-placement[data-amount]');
        instalments.forEach((placement) => this.attribute(placement.closest('.shopify-app-block') || placement, 'data-lb-hide-instalments', String(neutralPayment)));
        this.hide(this.querySelector('[data-lb-instalment-note]'), !neutralPayment || instalments.length === 0);
        this.text(this.scope.querySelector('pickup-availability .pickup-availability-info > p.caption'), this.messages.pickup_confirmation);
        document.querySelectorAll('pickup-availability-drawer .pickup-availability-list__item > p.pickup-availability-preview').forEach((line) => {
          if (line.textContent.trim()) this.text(line, this.messages.pickup_available_confirmation);
        });
        const mainButton = this.form.querySelector('button[name="add"]');
        const quantityUnavailable = variant.available && variant.inventory_managed && variant.inventory_policy !== 'continue' && model.quantity > variant.inventory_quantity;
        if (mainButton && quantityUnavailable && !mainButton.disabled) {
          this.quantityDisabledVariant = variant.id;
          mainButton.disabled = true;
        } else if (!quantityUnavailable && this.quantityDisabledVariant) {
          if (mainButton && this.quantityDisabledVariant === variant.id) mainButton.disabled = false;
          this.quantityDisabledVariant = null;
        }
        const label = model.dispatch === 'unavailable' ? this.messages.sold_out
          : model.dispatch === 'made_to_order' || model.dispatch === 'quantity_backorder' ? this.messages.made_to_order_button : this.messages.add_to_cart;
        this.text(mainButton?.querySelector(':scope > span'), label);
        const stickyButtons = Array.from(document.querySelectorAll('.sticky-atc-button')).filter((button) => button.getAttribute('form') === this.dataset.formId);
        stickyButtons.forEach((button) => {
          this.text(button.querySelector(':scope > span'), label);
          const disabled = Boolean(mainButton?.disabled || model.dispatch === 'unavailable');
          if (button.disabled !== disabled) button.disabled = disabled;
        });
        const stickyPrice = model.mode === 'deposit'
          ? this.messages.sticky_deposit.replace('__NOW__', this.money(model.dueNow)).replace('__TOTAL__', this.money(model.total))
          : this.messages.sticky_total.replace('__AMOUNT__', this.money(model.total));
        const stickyRoots = new Set(stickyButtons.map((button) => button.closest('.sticky-atc')).filter(Boolean));
        stickyRoots.forEach((root) => root.querySelectorAll('.sticky-atc-price').forEach((price) => {
          this.hide(price, false);
          let summary = price.querySelector('[data-lb-sticky-summary]');
          if (!summary) {
            summary = document.createElement('span');
            summary.setAttribute('data-lb-sticky-summary', '');
            price.appendChild(summary);
          }
          this.attribute(price, 'data-lb-synced', '');
          this.text(summary, stickyPrice);
        }));
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
